import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { withStyles, Slide, Radio, Checkbox } from "@material-ui/core";
import Selector2 from "../Selector2";
import {
  sources,
  // occupations,
  amounts,
  purposes,
} from "../../utils/level6Options";
import { images } from "../../utils/images";
import { pushNotification, fetchOccupations } from "../../actions/index";
import Loader from "../Loader";

function Experience(props) {
  const { classes, t, theme, occupations } = props;
  const [occupation, setOccupation] = useState("");
  const [otherOccupation, setOtherOccupation] = useState("");
  const [purpose, setPurpose] = useState("");
  const [otherPurpose, setOtherPurpose] = useState("");
  const [tradingAmount, setTradingAmount] = useState("");
  const [sourceOfFunds, setSourceOfFunds] = useState("");
  const [otherFunds, setOtherFunds] = useState("");
  const [usingForAntother, setUsingForAnother] = useState(false);
  const [isPEP, setIsPEP] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [occupationsArr, setOccupationsArray] = useState([]);
  const [jobTitle, setJobTitle] = useState("");

  useEffect(() => {
    if (occupations) {
      let occArr = occupations.map((o) => o.name);
      setOccupationsArray([...occArr]);
    } else {
      props.fetchOccupations();
    }
  }, [occupations]);

  const submitExperience = () => {
    let expObj = {
      occupation: occupation === "Other" ? otherOccupation.trim() : occupation,
      purpose_of_the_account: purpose === "Other" ? otherPurpose : purpose,
      estimated_trading_volume_per_month: tradingAmount,
      source_of_funds_type: sourceOfFunds,
      representing_someone_else: !usingForAntother,
      politically_exposed_person: !isPEP,
      job_title: jobTitle.trim(),
    };

    if (sourceOfFunds === "Other") {
      expObj.source_of_funds_description = otherFunds;
    }

    let missingFields = [];

    Object.keys(expObj).map((i) => {
      if (expObj[i] === "") {
        missingFields.push(i);
      }
    });

    if (missingFields.length) {
      setMissingFields(missingFields);
      return props.pushNotification({
        message: "missingFields",
        type: "error",
      });
    }

    props.addExperience(expObj);
    props.triggerLevel6(true);
  };

  if (occupations === null) {
    return (
      <div style={{ marginTop: 24 }}>
        <Loader />
      </div>
    );
  }

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <div className="stepBody">
          <div className={classes.miniTracker}>
            <h2>{t("tellUsExperience")}</h2>

            <p>
              2<b>/2</b>
            </p>
          </div>
          <div className="left">
            <p className="label">{t("howMuch")}</p>
            <Selector2
              options={amounts}
              selectorHandle={setTradingAmount}
              selectedOption={tradingAmount}
              invalid={
                missingFields.includes("estimated_trading_volume_per_month")
                  ? true
                  : false
              }
            />
            <p className="label">{t("occupation")}*</p>
            <Selector2
              options={occupationsArr}
              selectorHandle={setOccupation}
              selectedOption={occupation}
              invalid={missingFields.includes("occupation") ? true : false}
            />

            {occupation === "Other" ? (
              <input
                type="text"
                placeholder={t("specify")}
                onChange={(e) => setOtherOccupation(e.target.value)}
                className={`textInput ${
                  missingFields.includes("occupation") ? "invalidField" : ""
                }`}
              />
            ) : (
              ""
            )}
            <p className="label">{t("jobTitle")}</p>
            <input
              type="text"
              onChange={(e) => setJobTitle(e.target.value)}
              className={`textInput ${
                missingFields.includes("job_title") ? "invalidField" : ""
              }`}
              maxLength={64}
            />
            <p className="label">{t("howFunds")}</p>
            <Selector2
              options={sources}
              selectorHandle={setSourceOfFunds}
              selectedOption={sourceOfFunds}
              invalid={
                missingFields.includes("source_of_funds_type") ? true : false
              }
            />

            {sourceOfFunds === "Other" ? (
              <input
                type="text"
                placeholder={t("specify")}
                onChange={(e) => setOtherFunds(e.target.value)}
                className={`textInput ${
                  missingFields.includes("source_of_funds_description")
                    ? "invalidField"
                    : ""
                }`}
              />
            ) : (
              ""
            )}
            <p className="label">{t("_purposeOfAcc")}</p>
            <Selector2
              options={purposes}
              selectorHandle={setPurpose}
              selectedOption={purpose}
              invalid={
                missingFields.includes("purpose_of_the_account") ? true : false
              }
            />
            {purpose === "Other" ? (
              <input
                type="text"
                placeholder={t("specify")}
                onChange={(e) => setOtherPurpose(e.target.value)}
                className={`textInput ${
                  missingFields.includes("purpose_of_the_account")
                    ? "invalidField"
                    : ""
                }`}
              />
            ) : (
              ""
            )}
            <div className="checkbox_container">
              <Checkbox
                classes={{ root: classes.cbRoot, checked: classes.cbChecked }}
                onClick={() => setUsingForAnother(!usingForAntother)}
                checked={usingForAntother}
              />
              <p>{t("_usingForOther")}</p>
            </div>
            <div className="checkbox_container">
              <Checkbox
                classes={{ root: classes.cbRoot, checked: classes.cbChecked }}
                onClick={() => setIsPEP(!isPEP)}
                checked={isPEP}
              />
              <p>{t("_isPEP")}</p>
            </div>
            <button
              className="confirmBtn"
              disabled={!isPEP || !usingForAntother}
              onClick={() => submitExperience()}
            >
              {t("confirm")}
            </button>
          </div>
          <div className="right">
            <img
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
              src={images.illustrations.experienceIllustrationSolo}
            />
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {
    occupations: state.occupations,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pushNotification,
      fetchOccupations,
    },
    dispatch
  );
}

const styles = (theme) => ({
  miniTracker: {
    width: "100%",
    display: "flex",

    "& h2": {
      fontSize: 28,
      fontWeight: 600,
      marginBottom: 64,
      width: "90%",
    },

    "& p": {
      width: "10%",
      textAlign: "right",
      fontSize: 32,
      fontWeight: 600,
      color: theme.colors.buttons.green,
      "& b": {
        fontSize: 18,
      },
    },
  },
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,
    [theme.breakpoints.down(500)]: {
      padding: 24,
    },
    "& .stepBody": {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      flexWrap: "wrap",
      "& h2": {
        fontSize: 28,
        fontWeight: 600,
        marginBottom: 64,
        width: "100%",
      },

      "& .left": {
        width: "50%",
        position: "relative",

        "& .label": {
          fontSize: 16,
          color: theme.colors.text.primary,
          fontFamily: "Dm Sans, sans-serif",
          marginBottom: 8,
          marginTop: 16,
          fontWeight: 600,
          "&:first-of-type": {
            marginTop: 0,
          },
        },
        "& .selected": {
          marginRight: 0,
        },

        "& input": {
          ...theme.defaults.input,
          maxWidth: "none",
          marginTop: 8,
          "&.invalidField": {
            borderColor: theme.colors.buttons.sell,
          },
        },
        "& .checkbox_container": {
          display: "flex",
          alignItems: "flex-start",
          marginTop: 12,
          "& p": {
            fontSize: 16,
            fontFamily: "Titillium Web",
            lineHeight: "21px",
            color: theme.colors.text.primary,
            marginLeft: 5,
            fontWeight: 600,
          },
          "& input": {
            height: "auto !important",
          },
        },
        "& .confirmBtn": {
          ...theme.defaults.roundBtn,
          background: theme.colors.buttons.green,
          marginTop: 32,
          float: "right",
          width: 150,
        },
      },
      "& .right": {
        width: "45%",
      },
      [theme.breakpoints.down(700)]: {
        "& .left": {
          width: "100%",
        },
        "& .right": {
          display: "none",
        },
      },
    },
  },
  cbRoot: {
    padding: 0,
    color: theme.colors.text.primary,
  },
  cbChecked: {
    color: `${theme.colors.background.active} !important`,
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Experience))
);
